import React from "react";
import { Router as BrowserRouter } from "react-router-dom";
import { getAccessToken, getTgAccessToken } from "src/api";

import { ModalsSwitch, PagesSwitch } from "src/navigation/Switch";
import { history } from "src/navigation/store";
import { useHistory } from "src/navigation/useHistory";
import { useGetUserData } from "src/queries/useGetUserData";
import { ErrorBoundary } from "src/components/organisms/ErrorBoundary";
import { Loader } from "src/components/atoms/Loader";

export const Router: React.FC = () => {
  const { location, action } = useHistory();
  const accessToken = getAccessToken();
  const tgAccessToken = getTgAccessToken();
  const { user, isLoading } = useGetUserData();
  // Именно профиль, а не «хоть что-то пришло»: при сбое запроса пользователь
  // не должен считаться авторизованным, иначе интерфейс рисуется без данных.
  const isLogedinUser = (accessToken || tgAccessToken) && user;
  const mode = isLogedinUser ? "user" : "guest";

  if (isLoading) {
    // Пустой экран во время загрузки профиля читался как «сайт не работает».
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Loader />
      </div>
    );
  }

  return (
    <BrowserRouter
      location={location}
      navigationType={action}
      navigator={history}
    >
      <ErrorBoundary>
        <PagesSwitch mode={mode} />
        <ModalsSwitch mode={mode} />
      </ErrorBoundary>
    </BrowserRouter>
  );
};
